import { writable } from "svelte/store";
import { call } from "$lib/Api/Api.svelte";

const sources = writable([]);

const sourceStore = {
  subscribe: sources.subscribe,
  load: (id) => {
    return call("sources", "get")
      .then((data) => {
        sources.set(data);
      })
      .catch((err) => { });
  },
};

export default sourceStore;
